(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vimly-premium-header"] && !Shopify.designMode) return;
  try {
    
  const vimlyHeader = document.querySelector('[data-vimly-header]');
  const vimlyAnnouncement = vimlyHeader?.querySelector('.vimly-announcement');
  const syncVimlyHeader = () => {
    if (!vimlyHeader || !vimlyAnnouncement) return;
    vimlyHeader.classList.toggle('is-pinned', window.scrollY > vimlyAnnouncement.offsetHeight);
  };
  syncVimlyHeader();
  window.addEventListener('scroll', syncVimlyHeader, { passive: true });
  document.querySelectorAll('[data-vimly-header] details').forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open || item.closest('.vimly-mobile-drawer')) return;
      document.querySelectorAll('[data-vimly-header] .vimly-desktop-nav > details[open]').forEach((other) => {
        if (other !== item) other.removeAttribute('open');
      });
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-vimly-header] details[open]').forEach((item) => item.removeAttribute('open'));
  });

  } catch(e) { console.error(e); }
})();
})();
